var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('keep-alive',[_c(_vm.currentView,{tag:"component",attrs:{"changeView":_vm.changeView,"callbackChanged":_vm.callbackChanged}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }